module.exports = __webpack_public_path__ + "static/media/loading.ed9d9475.gif";